import { selfGuidedTourCardVerification } from 'constants/routes';
import { getAntiForgeryToken } from '../services/antiForgeryTokenService';

export default function requestCardVerification(specId, token, user) {
  return fetch(selfGuidedTourCardVerification, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'RequestVerificationToken': getAntiForgeryToken(),
    },
    body: JSON.stringify({
      verifyUserCardCommand: {
        SpecId: specId,
        Token: token,
        User: {
          FirstName: user.firstName,
          LastName: user.lastName,
          Email: user.email,
          PhoneNumber: user.phoneNumber,
        },
      },
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch((error) => {
      throw error;
    });
}
